import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";

import { MatchResponseType } from "./type";

export const MatchApi = {
  async getMatch() {
    const { data } = await axiosRequest.post<MatchResponseType>(
      "/",
      payloadHelper("Match", null, null)
    );

    return data;
  },
};
